import { NgIf } from '@angular/common'
import { Component } from '@angular/core'
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import {
    MatError,
    MatFormField,
    MatFormFieldModule,
    MatLabel,
} from '@angular/material/form-field'
import { MatIcon, MatIconModule } from '@angular/material/icon'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatStepperModule } from '@angular/material/stepper'
import { Location, LocationDTO } from '../../models/location.interface'
import { MatDialogRef } from '@angular/material/dialog'
import { ToastrService } from 'ngx-toastr'
import { LocationService } from '../../services/location/location.service'
import { HttpErrorResponse } from '@angular/common/http'

@Component({
    selector: 'app-location-form',
    standalone: true,
    imports: [
        MatStepperModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatError,
        MatIcon,
        MatIconModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgIf,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
    ],
    templateUrl: './location-form.component.html',
    styleUrl: './location-form.component.css',
})
export class LocationFormComponent {
    selectedLocation: Location | null = null
    locationId: string | null = null
    errorMsg: string[] | null = null

    constructor(
        private dialogRef: MatDialogRef<LocationFormComponent>,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private locationService: LocationService
    ) {}

    ngOnInit(): void {
        this.locationService.$locationsSelected.subscribe((location) => {
            if (location) {
                this.locationId = String(location.id)
                this.selectedLocation = location
                this.editLocationForm.patchValue({
                    ...location,
                })
            }
        })
    }

    editLocationForm = this.fb.group({
        country: ['', []],
        department: ['', []],
        city: ['', []],
        countryCode: [0, []],
        departmentCode: [0, []],
        cityCode: [0, []],
    })

    closeDialog() {
        this.dialogRef.close()
    }

    updateLocation() {
        const payload = this.editLocationForm.value as LocationDTO
        if (this.editLocationForm.status === 'VALID' && this.locationId) {
            if (this.editLocationForm.pristine) {
                this.dialogRef.close()
                return
            }
            const id = Number(this.locationId)
            this.locationService
                .updateLocation(id, { ...payload, id: id })
                .subscribe({
                    next: (location) => {
                        const msg = `El registro fue EDITADO correctamente!`
                        this.toastr.success(msg, 'Exitoso!', {
                            progressBar: true,
                            timeOut: 5000,
                        })
                        this.dialogRef.close()
                    },
                    error: ({}: HttpErrorResponse) => {
                        if (this.errorMsg) {
                            this.toastr.error(
                                'Error: ' + this.errorMsg,
                                undefined,
                                {
                                    progressBar: true,
                                    timeOut: 5000,
                                }
                            )
                        }
                    },
                })
        }
    }
}
